import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a04197b602770000722ca04/luxebeauty/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a04197b602770000722ca04/luxebeauty/src/app/homepage/components/BestsellersSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a04197b602770000722ca04/luxebeauty/src/app/homepage/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a04197b602770000722ca04/luxebeauty/src/app/homepage/components/TestimonialsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a04197b602770000722ca04/luxebeauty/src/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a04197b602770000722ca04/luxebeauty/src/components/ScrollReveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a04197b602770000722ca04/luxebeauty/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a04197b602770000722ca04/luxebeauty/src/components/ui/AppImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a04197b602770000722ca04/luxebeauty/src/components/ui/AppLogo.tsx");
